import * as Yup from "yup";

export const temporaryContactInfo = () => {
  return Yup.object().shape({
    returnedToHome: Yup.string()
      .oneOf(["Y", "N"], "Please indicate if you have returned home")
      .required("This field is required"),
    tempPhoneNumber: Yup.string().when("returnedToHome", {
      is: "Y",
      then: () => Yup.string().notRequired().nullable(),
      otherwise: () =>
        Yup.string().when("usePersonalNumber", {
          is: false,
          then: () =>
            Yup.string()
              .matches(
                /^\(\d{3}\) \d{3}-\d{4}$/,
                "Enter a valid 10-digit Canadian number."
              )
              .required("Temporary phone number is required"),
          otherwise: () => Yup.string().nullable(),
        }),
    }),
  });
};
